/**
 * Administracion Generica de usuarios
 */

//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const RESTABLECER_PASS_USUARIO = "restablecerPassUsuario";
export const RESTABLECER_PASS_USUARIO_PERFIL = "restablecerPassPerfil";
export const RESTABLECER_PASS_BY_EMAIL = "restablecerPassByEmail";
// mutations types

export const SET_USUARIO = "setUsuario";
const state = {
    usuario: []
}

const actions  = {
    /**
     * Actaulizar la contraseña del usuario desde un admin
     * @param {*} context 
     * @param {*} datosUsuario {id, pass}
     * @returns 
     */
     async [RESTABLECER_PASS_USUARIO](context, datosUsuario){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Usuarios/cambiarpass`, datosUsuario)
                .then(({ data }) => {
                    context.commit(SET_USUARIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },   



    /**
     * Actaulizar la contraseña del usuario desde su perfil
     * @param {*} context 
     * @param {*} datosUsuario {id, pass}
     * @returns 
     */
     async [RESTABLECER_PASS_USUARIO_PERFIL](context, datosUsuario){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Usuarios/cambiarpassperfil`, datosUsuario)
                .then(({ data }) => {
                    context.commit(SET_USUARIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });    
    },   


    /**
     * Restablecer la contraseña a traves de correo electrónico
     * @param {*} context 
     * @param {*} correo 
     */
    async [RESTABLECER_PASS_BY_EMAIL](context, datos){
        return new Promise(resolve => {
            ApiService.post(`apiconsume/create?endpoint=api/Usuarios/ActualizarPass/Correo`, datos)
                .then(({ data }) => {
                    context.commit(SET_USUARIO, data.data);
                    resolve(data)
                })
                .catch((error) => {
                    console.log(error)
                    //context.commit(SET_ERROR, response.data.errors);
                });
        });   
    }


}

const mutations = {
    [SET_USUARIO](state, data) {
        state.usuario = data;
    }
}


export default {
    state,
    actions,
    mutations
}